import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-outlets',
  templateUrl: './no-outlets.component.html',
  styleUrls: ['./no-outlets.component.css']
})
export class NoOutletsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
